import Rails from '@rails/ujs';


document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('form.search-view #query').forEach(function(el) {
    el.addEventListener('input', function(e) {
      var query = el.value;
      var clear = document.querySelector('form.search-view .clear-search');

      var page = document.querySelector('form.search-view #page');
      page.value = '0';

      if (query.length > 0) {
        clear.style.display = 'block';
      } else {
        clear.style.display = 'none';
      }

      if (query.length == 0 || query.length >= 3) {
        var form = el.parentNode;
        Rails.fire(form, 'submit');
      }
    });
  });

  document.querySelectorAll('form.search-view .clear-search').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();

      var query = document.querySelector('form.search-view #query');
      query.value = '';
      query.focus();

      var page = document.querySelector('form.search-view #page');
      page.value = '0';

      Rails.fire(query, 'input');
    });
  });

});
